import { FiCommentSettingType } from '@fi-shared/types';
import { IFiCustomerData } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { IDocumentCommonSettingModel } from '@fi-app/document/document';

export class DocumentCommonSettingModel implements IDocumentCommonSettingModel {
    SendPushMessages: boolean = true;
    IsNews: boolean;
    CommentSettingType: FiCommentSettingType = FiCommentSettingType.NoComments;
    CanShare: boolean;
    IsVerifyRead: boolean;
    IsPrintable: boolean;

    constructor(customerData: IFiCustomerData) {
        this.IsNews = customerData.CanShareAsNews;
    }

    Initialize(documentSetting: IDocumentCommonSettingModel) {
        this.IsNews = documentSetting.IsNews;
        this.SendPushMessages = documentSetting.SendPushMessages;
        this.IsPrintable = documentSetting.IsPrintable;
        this.IsVerifyRead = documentSetting.IsVerifyRead;
        this.CanShare = documentSetting.CanShare;
        this.CommentSettingType = documentSetting.CommentSettingType;
    }
}
